import React, { useState } from 'react';

import {
    makeStyles,
    IconButton,
    Typography,
    Divider
} from '@material-ui/core';
import {
    esGestiona,
    IconAdd,
    IconCerrar
} from '@portal/arq-portal-core';

import { EnlacesPersonales } from './EnlacesPersonales';
import { AddEnlacePersonal } from './AddEnlacePersonal';

const useEstilos = makeStyles((theme) => ({
    enlacesFavoritosSeccionContainer: {

    },
    titulo: {
        color: theme.palette.primary.main,
        padding: '0.5rem 0',
        fontWeight: 900
    },
    listaEnlaces: {
        padding: '0.3rem 0',
        color: '#888',
        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            marginLeft: '4px',
        }
    }, 
    cabecera: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    iconoAnadir: {
        backgroundColor: 'transparent !important',
        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            color: '#606060',
            width: '15px',
            '&:hover': {
                color:'#919191'
            },
            '&:focus, &:active': {
                color:'#DC0028',
            },
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },

    divExterior: {
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    titulo2: {
        // marginBottom: '8px',
        fontWeight: 'bold',
        // @ts-ignore
        color: props => props?.colorTitulo ? props?.colorTitulo : theme.palette.primary.main
    },
    divider: {
        // @ts-ignore
        background: props => props?.colorDivisor?  props.colorDivisor: theme.palette.primary.main,
        height: '2px'
    },
    iconoAnadir2: {
        backgroundColor: 'transparent !important',
        '& .MuiSvgIcon-root': {
            fontSize: '14px',
            color: '#606060',
            width: '15px',
            '&:hover': {
                color:'#919191'
            },
            '&:focus, &:active': {
                color:'#DC0028',
            },
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },
    textAnadir:{
        margin: '0px !important',
        textDecoration:'underline',
        color: theme.palette.primary.main,
        fontSize:'12px',
        cursor:'pointer',
        
        '&:hover': {
            fontWeight:'bold'
        },
    }

}));

interface Props {
    personales: any[];
};

export const EnlacesPersonalesSeccion = ({ personales }: Props) => {
    const [iconoMasActivo, setIconoMasActivo] = useState(false);
    const clases = useEstilos();

    return (
        <div>
            { !esGestiona() && <div>
                <React.Fragment>
                    <div className={clases.divExterior}>
                        <Typography variant="body2" component="div" classes={{ root: clases.titulo2 }}>Enlaces externos</Typography>
                        <div style={{flex: '1 1 0'}}></div>
                        <p className={clases.textAnadir} onClick={() => setIconoMasActivo(prev => !prev)}> Añadir enlace </p>
                    </div>
                    <Divider classes={{root:clases.divider}}></Divider>
                </React.Fragment> 
            </div>
            }
            {
                esGestiona() && 
                <div className={clases.cabecera}>
                    <Typography variant="caption" component="div" classes={{ root: clases.titulo }}>Enlaces Personales</Typography>
                    <div style={{flex: '1 1 0'}}></div>
                    <IconButton className={clases.iconoAnadir} aria-label="close" size="small" onClick={() => setIconoMasActivo(prev => !prev)}>
                        {
                            iconoMasActivo ?
                                <IconCerrar /> :
                                <IconAdd />
                        }
                    </IconButton>
                </div>
            }
            
            {iconoMasActivo ?
                <AddEnlacePersonal mostrarFormulario={setIconoMasActivo} /> :
                <EnlacesPersonales items={personales} />   
            }
        </div>

        
    )
};
